// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { sign } = Math;
